import { render } from "./SocialLinks.vue?vue&type=template&id=85f723ce&ts=true"
import script from "./SocialLinks.vue?vue&type=script&lang=ts"
export * from "./SocialLinks.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__